import Navbar from "components/Common/Navbar/Navbar";
import About from "components/About/About";
import Service from "components/Service/Service";
import Skills from "components/Skills/Skills";
import Resume from "components/Resume/Resume";
import Blog from "components/Blog/Blog";
import Contact from "components/Contact/Contact";
import Footer from "components/Common/Footer/Footer";
import ScrollToTop from "react-scroll-to-top";
import Events from "components/Events/Events";

const HomePage = () => (
  <div>
    <Navbar />
    <div className="container pb-4">
      <About />
      <Service />
      <Skills />
      <Resume />
      <Blog />
      <Events />
      <Contact />
      <Footer />
    </div>
    <ScrollToTop
      smooth
      id="top-scroll"
      color="var(--color-secondary)"
      viewBox="0 0 500 500"
      svgPath="M397.7,376.1c20.4,20.4,53.6,20.4,74,0s20.4-53.6,0-74L280.5,110.9c-20.4-20.4-53.6-20.4-74,0L15.3,302.1
      c-20.4,20.4-20.4,53.6,0,74s53.6,20.4,74,0l154.2-154.2L397.7,376.1z"
    />
  </div>
);

export default HomePage;
